import format from 'date-fns/format';
import React, { useCallback } from 'react';
import { AiOutlineReload } from 'react-icons/ai';
import {
  MdInfo,
  MdOutlineErrorOutline,
  MdOutlineFilterAlt,
} from 'react-icons/md';
import { RiDownloadLine } from 'react-icons/ri';
import { toast } from 'react-toastify';

import {
  TableCell,
  TableRow,
  Tooltip,
  WrapperFlex,
} from '@unimed-fesp/components';

import { useSelector } from 'react-redux';
import theme from '../../../styles/theme';
import { Chip } from '../../atoms/Chip';
import {
  ButtonActions,
  ConstainerTooltip,
  Container,
  CustomTooltip,
  CustomTooltipText,
  HoverActions,
} from './styles';
import { ErrorToast } from '../Toast';

const TableBodyRelatorios = ({
  relatorios,
  openModalInformacoes,
  reprocessarTask,
  obterErrosDeTask,
  downloadRelatorio,
}) => {
  const { getArquivo } = useSelector((state) => state.arquivoUpload);
  const { putReprocessarTask } = useSelector((state) => state.task);

  const chipColors = {
    1: theme.greenDefault,
    2: theme.blue,
    3: theme.redDefault,
    4: theme.orangeDefault,
  };
  const reprocessarRelatorio = useCallback((relatorio) => {
    if (relatorio.podeReprocessar) return reprocessarTask(relatorio.taskId);

    return toast.error(
      <ErrorToast size="150">
        Não será possível reprocessar o relatório porque foram encontrados um ou
        mais erros referentes aos dados dos beneficiários. Por gentileza,
        corrija estes dados e emita um novo relatório. Você pode encontrar mais
        detalhes destes erros clicando no botão de detalhamento
      </ErrorToast>
    );
  }, []);

  return (
    <>
      {relatorios.map((relatorio) => {
        return (
          <TableRow key={relatorio.taskId}>
            <TableCell width={250}>
              <WrapperFlex gap={5} justifySpaceBetween alignCenter>
                {relatorio.nomeArquivo ? relatorio.nomeArquivo : '-'}
              </WrapperFlex>
            </TableCell>
            <TableCell width={200}>
              <Chip backgroundColor={chipColors[relatorio.status]}>
                {relatorio.descricaoStatus || '-'}
                {!relatorio.podeReprocessar && <MdInfo size={20} />}
              </Chip>
            </TableCell>
            <TableCell width={150}>
              {relatorio.criadoEm
                ? format(new Date(relatorio.criadoEm), 'dd/MM/yyyy HH:mm', {
                    timeZone: 'America/Sao_Paulo',
                  })
                : '-'}
            </TableCell>
            <TableCell width={150}>
              {relatorio.finalizadoEm
                ? format(new Date(relatorio.finalizadoEm), 'dd/MM/yyyy HH:mm', {
                    timeZone: 'America/Sao_Paulo',
                  })
                : '-'}
            </TableCell>
            <TableCell>
              <WrapperFlex gap={10}>
                <HoverActions>
                  <Tooltip
                    background={theme.greenDefault}
                    color={theme.bgWhite}
                    position="top"
                    text="Download"
                  >
                    <ButtonActions
                      width={40}
                      padding={5}
                      justifyCenter
                      disabled={relatorio.status !== 1 || getArquivo.loading}
                      onClick={() =>
                        downloadRelatorio(relatorio.arquivoId, relatorio.taskId)
                      }
                    >
                      <RiDownloadLine color={theme.white} size={16} />
                    </ButtonActions>
                  </Tooltip>
                </HoverActions>
                <HoverActions>
                  <Tooltip
                    background={theme.blue}
                    color={theme.bgWhite}
                    position="top"
                    text="Filtros Aplicados"
                  >
                    <ButtonActions
                      width={40}
                      padding={5}
                      justifyCenter
                      onClick={() =>
                        openModalInformacoes({
                          isOpen: true,
                          taskId: relatorio.taskId,
                        })
                      }
                      background={theme.blue}
                    >
                      <MdOutlineFilterAlt color={theme.white} size={16} />
                    </ButtonActions>
                  </Tooltip>
                </HoverActions>
                <HoverActions>
                  <Tooltip
                    color={theme.bgWhite}
                    position="top"
                    text="Reprocessar agora"
                    background={theme.orangeDefault}
                  >
                    <ButtonActions
                      width={40}
                      padding={5}
                      justifyCenter
                      disabled={
                        relatorio.status === 1 ||
                        relatorio.status === 2 ||
                        putReprocessarTask.loading
                      }
                      onClick={() => reprocessarRelatorio(relatorio)}
                      background={theme.orangeDefault}
                    >
                      <AiOutlineReload color={theme.white} size={16} />
                    </ButtonActions>
                  </Tooltip>
                </HoverActions>

                <HoverActions>
                  <Tooltip
                    background={theme.redDefault}
                    color={theme.bgWhite}
                    position="top"
                    text="Erros"
                  >
                    <ButtonActions
                      width={40}
                      padding={5}
                      justifyCenter
                      disabled={relatorio.status !== 3}
                      onClick={() =>
                        obterErrosDeTask(
                          relatorio.taskId,
                          relatorio.podeReprocessar
                        )
                      }
                      background={theme.redDefault}
                    >
                      <MdOutlineErrorOutline color={theme.white} size={16} />
                    </ButtonActions>
                  </Tooltip>
                </HoverActions>
              </WrapperFlex>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default TableBodyRelatorios;
